import * as React from 'react';

const SvgGreyBlob = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 101 89" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.248.289c13.62 1.699 20.155 15.775 28.993 26.268 9.37 11.122 25.031 20.526 22.482 34.84-2.594 14.57-19.213 21.398-33.307 25.954-11.549 3.733-23.167.59-34.371-4.077-12.369-5.152-25.987-10.363-30.53-22.96C-2.591 46.16.247 29.859 9.493 17.983 18.864 5.945 34.103-1.6 49.248.289z"
      fill="currentColor"
    />
  </svg>
);

export default SvgGreyBlob;
